










import {Component, Vue} from 'vue-property-decorator';
import {
  Action,
} from 'vuex-class';
import { Auth } from 'aws-amplify';

@Component
export default class Pusher extends Vue {
  @Action('user/push/subscribe') private subscribe!: (subscription: any) => Promise<void>;
  private register: any;
  private isSubscribed: boolean = false;
  private denied: boolean = false;
  private loading: boolean = true;
  private publicVapidKey: string = 'BLa6_YdxFqTY_Oq3d4PdxGW9041g3fLqoUSW3Y-Vyi7kbezqaS7brQ53d4fQ6NfVfNY42eVQA-V7QKmDX' +
    'XkBMkA';


  private async mounted() {
    if (Notification.permission === 'denied') {
      this.loading = false;
      this.denied = true;
      return;
    }
    this.register = await navigator.serviceWorker.register('/worker.js', {
      scope: '/',
    });
    // tslint:disable-next-line
    console.log('get sub');

    this.register.pushManager.getSubscription()
      .then((subscription: any) => {
        this.isSubscribed = !(subscription === null);
        this.loading = false;

        if (this.isSubscribed) {
          Auth.currentAuthenticatedUser().then((user) => {
            Auth.updateUserAttributes(user, {
              'custom:endpoint': subscription.endpoint,
            });
          });
        }
      });
  }

  private async localSubscribe() {
    this.loading = true;
    const subscription = await this.register.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: this.urlBase64ToUint8Array(this.publicVapidKey),
    })
      .then((data: any) => {
        this.isSubscribed = data;
        return data;
      })
      .catch((err: any) => {
        // TODO handle err
      });

    this.loading = false;
    // TODO do subscription
    this.subscribe(subscription);
  }

  private urlBase64ToUint8Array(base64String: any) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
      .replace(/\-/g, '+')
      .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }
}
